import {IDocJournalData} from 'components/widget/items/documents-publication-pie-chart/doc-journal-pie-chart';
import {INewsData} from 'components/widget/items/news/news';
import {ICorrNum, INobComponent} from 'components/widget/items/nob-components-bar-chart/nob-components-bar-chart';
import {IRequestsTableData} from 'components/widget/items/request-table/request-table';
import {IContextRawData} from 'modules/context/context-types';
import {TRequestTableResponseWithPagination} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

export type TFetchRequestsDataArgs = Pick<IContextRawData, 'startDate' | 'endDate'>;
export const fetchRequestsData = ({
    startDate,
    endDate,
}: TFetchRequestsDataArgs) => (
    performRequest<IRequestsTableData>({
        url: '/widgets/requests-statistics',
        method: 'GET',
        params: {
            startDate,
            endDate,
        },
    }));

export type TFetchDocJournalDataArgs = Required<Pick<IContextRawData, 'organizationId' | 'taxPeriodId'>>;
export const fetchDocJournalData = ({
    organizationId,
    taxPeriodId,
}: TFetchDocJournalDataArgs) => (
    performRequest<IDocJournalData[]>({
        url: '/widgets/doc-journal',
        method: 'GET',
        params: {
            taxPeriodId,
            organizationId,
        },
    })
);

export type TFetchNobComponentsCorrNumListArgs = Omit<TFetchDocJournalDataArgs, 'userId'>;
export const fetchNobComponentsCorrNumList = ({
    organizationId,
    taxPeriodId,
}: TFetchNobComponentsCorrNumListArgs) => (
    performRequest<ICorrNum[]>({
        url: '/widgets/nob-components/corr-num',
        method: 'GET',
        params: {
            taxPeriodId,
            organizationId,
        },
    })
);

export type TFetchNobComponentsData = {docId: number}
export const fetchNobComponentsData = ({
    docId,
}: TFetchNobComponentsData) => (
    performRequest<INobComponent[]>({
        url: '/widgets/nob-components',
        method: 'GET',
        params: {
            docId,
        },
    })
);

export const fetchNews = () => (
    performRequest<TRequestTableResponseWithPagination<INewsData>>({
        url: '/widgets/news',
        method: 'GET',
    })
);
